var _path, _path2, _path3, _circle, _circle2, _circle3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _rect2, _path13, _rect3, _path14, _path15, _polygon2, _path16, _circle4, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYbwLandingOnboarding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 949.85,
    height: 469.99,
    viewBox: "0 0 949.85 469.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m767.55,468H115.11c-8.14,0-14.76-6.62-14.76-14.76V14.76c0-8.14,6.62-14.76,14.76-14.76h652.44c8.14,0,14.76,6.62,14.76,14.76v438.47c0,8.14-6.62,14.76-14.76,14.76Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m767.55,468H115.11c-8.14,0-14.76-6.62-14.76-14.76V14.76c0-8.14,6.62-14.76,14.76-14.76h652.44c8.14,0,14.76,6.62,14.76,14.76v438.47c0,8.14-6.62,14.76-14.76,14.76ZM115.11,6c-4.83,0-8.76,3.93-8.76,8.76v438.47c0,4.83,3.93,8.76,8.76,8.76h652.44c4.83,0,8.76-3.93,8.76-8.76V14.76c0-4.83-3.93-8.76-8.76-8.76H115.11Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m779.31,14.76v12.12H103.35v-12.12c0-6.5,5.27-11.76,11.76-11.76h652.44c6.5,0,11.76,5.27,11.76,11.76Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.74,
    cy: 14.8,
    r: 3.45,
    fill: "#fff",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.25,
    cy: 14.8,
    r: 3.45,
    fill: "#fff",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.76,
    cy: 14.8,
    r: 3.45,
    fill: "#fff",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161.48,
    y: 39.55,
    width: 552.22,
    height: 17.84,
    rx: 8.92,
    ry: 8.92,
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m339.08,251.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Zm-118.96-123.74c-4.97,0-9.02,4.05-9.02,9.02v101.7c0,4.97,4.05,9.02,9.02,9.02h118.96c4.97,0,9.02-4.05,9.02-9.02v-101.7c0-4.97-4.05-9.02-9.02-9.02h-118.96Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m500.81,251.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Zm-118.96-123.74c-4.97,0-9.02,4.05-9.02,9.02v101.7c0,4.97,4.05,9.02,9.02,9.02h118.96c4.97,0,9.02-4.05,9.02-9.02v-101.7c0-4.97-4.05-9.02-9.02-9.02h-118.96Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m662.54,251.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Zm-118.96-123.74c-4.97,0-9.02,4.05-9.02,9.02v101.7c0,4.97,4.05,9.02,9.02,9.02h118.96c4.97,0,9.02-4.05,9.02-9.02v-101.7c0-4.97-4.05-9.02-9.02-9.02h-118.96Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m339.08,410.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Zm-118.96-123.74c-4.97,0-9.02,4.05-9.02,9.02v101.7c0,4.97,4.05,9.02,9.02,9.02h118.96c4.97,0,9.02-4.05,9.02-9.02v-101.7c0-4.97-4.05-9.02-9.02-9.02h-118.96Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m500.81,410.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Zm-118.96-123.74c-4.97,0-9.02,4.05-9.02,9.02v101.7c0,4.97,4.05,9.02,9.02,9.02h118.96c4.97,0,9.02-4.05,9.02-9.02v-101.7c0-4.97-4.05-9.02-9.02-9.02h-118.96Z",
    fill: "#dfdfdf",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m662.54,410.04h-118.96c-7.18,0-13.02-5.84-13.02-13.02v-101.7c0-7.18,5.84-13.02,13.02-13.02h118.96c7.18,0,13.02,5.84,13.02,13.02v101.7c0,7.18-5.84,13.02-13.02,13.02Z",
    fill: "#387559",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m0,468.3c0,.94,1.07,1.69,2.41,1.69h945.03c1.33,0,2.41-.75,2.41-1.69s-1.07-1.69-2.41-1.69H2.41c-1.33,0-2.41.75-2.41,1.69Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m702.47,89.43l12.27-9.55s14,4.36,14.36,4.54,21.73,49.74,21.73,49.74c0,0-54.74,28.02-50.74,25.28,4-2.72,3.17-39.65-.55-44.46-3.73-4.82-.55-16.92-.55-16.92l3.45-8.64h.02Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "736.39 111.76 719.75 111.76 719.75 138.16 738.1 132.13 736.39 111.76",
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-e8a90abb-812c-425b-81fc-a172025cdd8e-44-44-47-50",
    d: "m682.03,282.01c.43-2.41.26-4.9-.5-7.26l5.8-24.93-12.37-2.59-4.54,25.57c-1.48,1.96-2.44,4.26-2.8,6.68-1,6.05,1.43,11.53,5.41,12.22,3.98.7,8.01-3.64,9.01-9.69h0Z",
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 714.02,
    y: 427.7,
    width: 17.18,
    height: 24.37,
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m697.3,466.82c7.54,0,18.55-.79,18.63-.8,2.95.26,17.65,1.42,18.38-1.94.67-3.09-.32-6.32-.46-6.77-1.42-14.05-1.94-14.22-2.26-14.31-.5-.15-1.96.55-4.33,2.08l-.15.1-.03.17c-.04.21-1.09,5.37-6.07,4.59-3.41-.54-4.52-1.3-4.87-1.67.29-.13.65-.36.9-.75.37-.57.43-1.31.19-2.2-.64-2.33-2.56-5.78-2.64-5.93l-.22-.39-19.52,13.17-12.06,3.45c-.91.25-1.64.91-2.01,1.78h0c-.51,1.21-.2,2.63.79,3.51,2.19,1.97,6.55,5.34,11.11,5.76,1.21.11,2.82.16,4.63.16h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 770.69,
    y: 411.25,
    width: 17.18,
    height: 24.37,
    transform: "translate(-106.02 476.52) rotate(-31.95)",
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m760.75,463.49c2.4,0,5.05-.34,7.28-1.47,5.63-2.83,19.32-12.78,19.4-12.85,2.63-1.33,15.72-8.13,14.56-11.37-1.07-2.98-3.62-5.2-3.97-5.5-8.64-11.18-9.16-11.04-9.48-10.95-.51.14-1.37,1.5-2.58,4.05l-.07.16.07.16c.08.21,1.92,5.14-2.72,7.1-3.18,1.35-4.52,1.3-5.01,1.16.18-.27.36-.65.37-1.12.02-.68-.32-1.35-1-1.97-1.78-1.64-5.23-3.55-5.38-3.63l-.39-.21-9.6,21.51-8.41,9.3c-.64.7-.91,1.64-.76,2.58h0c.21,1.3,1.23,2.33,2.53,2.56,1.32.23,3.17.48,5.19.48h0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m743.85,223.88s5.57,0,14.3,17.46c8.73,17.47-2.38,87.57-2.38,87.57l31.1,80.48-21.82,15.28-39.83-86.2,9.82,95.48h-24.55l-19.1-165.32,4.36-44.74h48.1s0,0,0,0Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "747.59 127.86 714.31 127.86 684.3 226.61 767.77 226.61 747.59 127.86",
    fill: "#387559",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m719.57,127.86l-33.83,140.22h-16.92s25.64-129.85,27.83-135.31c2.18-5.46,22.91-4.91,22.91-4.91h0Z",
    fill: "#387559",
    strokeWidth: 0
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.03,
    cy: 100.78,
    r: 18.28,
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m699.26,97.45l4.48.76c4.18-16.74,13.65-11.27,14.55-11.46s14.36,14.54,13.27,29.46c-1.09,14.91,18.19,21.9,18.19,21.9,0,0,6.74,12.66.73,35.57s6.73,30.6,6.73,30.6c25.1-2.13,10.01-37.15,6.01-43.51-4-6.37-1.27-17.46-1.27-17.46,6.19-5.46-1.09-17.46-1.09-17.46,0,0,1.28-16.01-2.54-19.1-3.82-3.09-4-10.73-4-10.73-6.74-29.28-28.74-23.64-28.74-23.64-28.19-3.09-26.31,25.06-26.31,25.06Z",
    fill: "#2f2e43",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-dec0bcbe-f1ad-43aa-8153-40375ac32d1e-45-45-48-51",
    d: "m782.02,279.08h0c-.46-2.41-1.5-4.68-3.05-6.61l-3.44-25.37-12.49,1.98,4.83,25.52c-.67,2.36-.75,4.84-.24,7.24,1.21,6.01,5.42,10.26,9.39,9.5,3.97-.76,6.21-6.25,4.99-12.26h0Z",
    fill: "#f2a2a5",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m764.4,266.43h16.92s-25.64-129.85-27.83-135.31c-2.18-5.46-20.44-3.14-20.44-3.14,0,0,31.35,138.45,31.35,138.45Z",
    fill: "#387559",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYbwLandingOnboarding);
export default __webpack_public_path__ + "static/media/ybw_landing_onboarding.68ff39f4baf082052b24e9b5bf05f8cc.svg";
export { ForwardRef as ReactComponent };